import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { StrikerBrand } from '@striker/ui-shell';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [debugLink, setDebugLink] = useState<string | null>(null);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    setDebugLink(null);
    try {
      const res = await fetch('/api/v1/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const body = (await res.json().catch(() => ({}))) as {
        message?: string;
        error?: string;
        debug_reset_token?: string;
      };
      if (!res.ok) {
        throw new Error(body.error || body.message || `Richiesta fallita (${res.status})`);
      }
      setDone(true);
      if (body.debug_reset_token) {
        setDebugLink(`/reset-password?token=${encodeURIComponent(body.debug_reset_token)}`);
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="sk-login">
      <form className="sk-login__card" onSubmit={onSubmit}>
        <div className="sk-login__brand">
          <StrikerBrand surface="dark" title="StrikerPos" />
        </div>
        <h1 className="sk-page__title">Recupero password</h1>
        <p className="sk-page__lead">
          <Link to="/login">← Torna al login</Link>
        </p>

        {done ? (
          <>
            <p className="sk-muted">
              Se l’account esiste, riceverai le istruzioni per reimpostare la password.
            </p>
            {debugLink ? (
              <p className="sk-muted">
                Debug locale: <Link to={debugLink}>apri reset</Link>
              </p>
            ) : null}
          </>
        ) : (
          <>
            <label className="sk-field">
              <span>Email</span>
              <input
                className="sk-input"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </label>
            {error ? <p className="sk-error">{error}</p> : null}
            <button type="submit" className="sk-btn sk-btn--block" disabled={busy}>
              {busy ? 'Invio…' : 'Invia link di recupero'}
            </button>
          </>
        )}
      </form>
    </div>
  );
}
